export default __webpack_public_path__ + "_/images/app/manual/manual4-d39a61ec9787dad21112a776aad1f0bea6bef2c408f19c8ff69521e32cfc6c95.png";